import { DEFAULT_PARDOT_REGION } from "../constants/generalConstants";

const listingEnquiryFormForRegion = {
	au: "https://ww2.office-hub.com/l/548422/2019-08-31/6pt3k",
	sg: "https://ww2.office-hub.com/l/548422/2020-04-02/b522b",
	nz: "https://ww2.office-hub.com/l/548422/2020-04-02/b522d",
	hk: "https://ww2.office-hub.com/l/548422/2020-04-02/b53bb",
	ph: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qhb",
	th: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qhd",
	my: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qhg",
	vn: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qhj",
	us: "https://ww2.office-hub.com/l/548422/2020-04-06/b9phs",
	uk: "https://ww2.office-hub.com/l/548422/2020-09-28/jnv1j",
	za: "https://ww2.office-hub.com/l/548422/2020-09-28/jnv1g"
};
const homepageEnquiryFormForRegion = {
	au: "https://ww2.office-hub.com/l/548422/2019-07-26/68ydb",
	sg: "https://ww2.office-hub.com/l/548422/2020-04-02/b5266",
	nz: "https://ww2.office-hub.com/l/548422/2020-04-02/b5268",
	hk: "https://ww2.office-hub.com/l/548422/2020-04-02/b53b6",
	ph: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qjv",
	th: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qjx",
	my: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qjz",
	vn: "https://ww2.office-hub.com/l/548422/2020-04-05/b7qk2",
	us: "https://ww2.office-hub.com/l/548422/2020-04-06/b9phx",
	uk: "https://ww2.office-hub.com/l/548422/2020-09-28/jnv2j",
	za: "https://ww2.office-hub.com/l/548422/2020-09-28/jnv2g"
};

export const ListingEnquiryFormUrl = region => {
	if (!region || region.length > 2) {
		return listingEnquiryFormForRegion[DEFAULT_PARDOT_REGION];
	}

	return (
		listingEnquiryFormForRegion[region.toLowerCase()] ||
		listingEnquiryFormForRegion[DEFAULT_PARDOT_REGION]
	);
};
export const HomepageEnquiryFormUrl = (region: string) => {
	if (!region || region.length > 2) {
		return homepageEnquiryFormForRegion[DEFAULT_PARDOT_REGION];
	}

	return (
		homepageEnquiryFormForRegion[region.toLowerCase()] ||
		homepageEnquiryFormForRegion[DEFAULT_PARDOT_REGION]
	);
};


const FALLBACK_REGION = "au";

const bookTourAssociationFormHandlerURLForRegion = {
	au: "https://ww2.office-hub.com.au/l/548422/2020-06-22/fcnts",
	sg: "https://ww2.office-hub.com.sg/l/548422/2020-06-22/fcnts",
	nz: "https://ww2.office-hub.co.nz/l/548422/2020-06-22/fcnts",
	hk: "https://ww2.office-hub.com.hk/l/548422/2020-06-22/fcnts",
	ph: "https://ww2.office-hub.com.ph/l/548422/2020-06-22/fcnts",
	th: "https://ww2.office-hub.co.th/l/548422/2020-06-22/fcnts",
	my: "https://ww2.office-hub.com.my/l/548422/2020-06-22/fcnts",
	vn: "https://ww2.office-hub.com.vn/l/548422/2020-06-22/fcnts",
	us: "https://ww2.office-hub.com/l/548422/2020-06-22/fcnts"
};

// Complete submissions only
// All regions use the same form, except for ZA
const quoteRequestCompleteFormHandler = {
	au: "https://ww2.office-hub.com/l/548422/2021-05-05/rrfcx",
	za: "https://ww2.office-hub.com/l/548422/2021-05-05/rrfdj"
};

// Incomplete submissions only
// All regions use the same form, except for ZA
const quoteRequestIncompleteFormHandler = {
	au: "https://ww2.office-hub.com/l/548422/2021-05-24/s97yz",
	za: "https://ww2.office-hub.com/l/548422/2021-05-24/s97z2"
};

export const BookTourAssociationFormHandler = (region = "au") => {
	return (
		bookTourAssociationFormHandlerURLForRegion[region.toLowerCase()] ||
		bookTourAssociationFormHandlerURLForRegion[FALLBACK_REGION]
	);
};

export const QuoteRequestFlowModalFormHandler = (
	region = "au",
	isComplete = false
) => {
	return isComplete
		? quoteRequestCompleteFormHandler[region.toLowerCase()] ||
		quoteRequestCompleteFormHandler[FALLBACK_REGION]
		: quoteRequestIncompleteFormHandler[region.toLowerCase()] ||
		quoteRequestIncompleteFormHandler[FALLBACK_REGION];
};

// For general associations of users, use this Form Handler URL.
export const MiscellaneousFormHandler = () =>
	"https://ww2.office-hub.com/l/548422/2021-03-24/qn9hn";

	const allowedRegionsForSinglePardotForm = ["in"];

	export const isSinglePardotFormAllowed = (region: string): boolean => {
		if (!region || region.length !== 2) {
			return false;
		}
		return allowedRegionsForSinglePardotForm.includes(region.toLowerCase());
	};